#version 300 es
precision highp float;

in float a_index;in vec2 a_shape;
in vec4 a_particle_pos;

uniform float u_particles_res;
uniform vec2 u_x_range;
uniform vec2 u_y_range;
uniform float u_point_size;

out vec2 v_particle_pos;
out vec4 v_particle_color;

mat2 rotate(float rad){
    float s=sin(rad);
    float c=cos(rad);
    
    return mat2(
        c,-s,
        s,c
    );
}

void main(){
    vec2 diff=a_particle_pos.zw;
    float len=length(diff);
    
    // v_particle_color=vec4(vec3(.3,.4,.4),len);
    v_particle_color=vec4(1.,1.,1.,len);
    
    float angle=atan(diff.x,diff.y);
    
    vec2 pos=a_shape*rotate(angle)+a_particle_pos.xy;
    gl_Position=vec4(2.*vec2(pos.x,1.-pos.y)-1.,0,1);
}
